<template>
  <div id="company-signup">
    <SignupSteps :status="currentStep"/>
    <b-form @submit.prevent ref="form" :validated="validated" novalidate>
      <component :is="currentFieldset" @submit-form="submitForm" @remove-company="removeCompany"
                 :formData="formData"/>
    </b-form>
  </div>
</template>

<script>
  import Address from '@/utils/Address'
  import api from '@/utils/api'
  import Person from '@/utils/Person'
  import EventBus from '@/utils/EventBus'
  import merge from 'deepmerge'
  import SignupFieldsetAddress from '@/components/SignupFieldsetAddress'
  import SignupFieldsetAdmin from '@/components/SignupFieldsetAdmin'
  import SignupFieldsetCompany from '@/components/SignupFieldsetCompany'
  import SignupFieldsetComplete from '@/components/SignupFieldsetComplete'
  import SignupFieldsetDirectors from '@/components/SignupFieldsetDirectors'
  import SignupFieldsetEmail from '@/components/SignupFieldsetEmail'
  import SignupFieldsetShareholders from '@/components/SignupFieldsetShareholders'
  import SignupFieldsetSubscription from '@/components/SignupFieldsetSubscription'
  import SignupSteps from '@/components/SignupSteps'

  const fieldsets = [SignupFieldsetEmail, SignupFieldsetCompany, SignupFieldsetAddress, SignupFieldsetDirectors,
    SignupFieldsetShareholders, SignupFieldsetAdmin, SignupFieldsetSubscription, SignupFieldsetComplete]
  const initialFormData = {
    name: '',
    businessType: '',
    registrationNo: '',
    regAddress: new Address(),
    mailAddress: new Address(),
    directors: [],
    shareHolders: [],
    admin: {
      email: '',
      firstName: '',
      lastName: '',
      gender: '',
      dateOfBirth: new Date(''),
      dob: '',
      addressLine1: '',
      city: '',
      postcode: '',
      password: ''
    },
    activeOfficers: [],
    chPSC: [],
    companyDirectors: [new Person()],
    selectedDirector: ['', ''],
    companyShareholders: [],
    invitations: [],
    plan: 'monthly'
  }

  export default {
    components: {
      SignupSteps
    },
    computed: {
      currentFieldset () {
        return fieldsets[this.currentIndex]
      },
      currentStep () {
        if (this.currentFieldset === SignupFieldsetEmail) return 1
        else if (this.currentFieldset === SignupFieldsetSubscription) return 3
        else if (this.currentFieldset === SignupFieldsetComplete) return 4
        else return 2
      }
    },
    data () {
      return {
        currentIndex: localStorage.currentIndex ? parseInt(localStorage.currentIndex) : 0,
        formData: localStorage.formData ? this.parseFormData() : initialFormData,
        isValid: false,
        regToken: localStorage.regToken ? localStorage.regToken : '',
        validated: false
      }
    },
    methods: {
      changeFieldset (step) {
        this.validated = false
        EventBus.$emit('hide-notification')
        this.currentIndex = this.currentIndex + step
        localStorage.setItem('currentIndex', this.currentIndex)
      },
      parseFormData () {
        const data = JSON.parse(localStorage.formData)
        data.incorporationDate = new Date(data.incorporationDate ? data.incorporationDate : '')
        data.admin.dateOfBirth = new Date(data.admin.dateOfBirth ? data.admin.dateOfBirth : '')
        const people = [data.activeOfficers, data.companyDirectors, data.companyShareholders]
        people.forEach(a => {
          a.forEach(p => {
            p.dateOfBirth = new Date(p.dateOfBirth ? p.dateOfBirth : '')
          })
        })
        return data
      },
      removeCompany () {
        this.formData.name = initialFormData.name
        this.formData.businessType = initialFormData.businessType
        this.formData.registrationNo = initialFormData.registrationNo
        this.formData.regAddress = initialFormData.regAddress
        this.formData.mailAddress = initialFormData.mailAddress
        this.formData.activeOfficers = initialFormData.activeOfficers
        this.formData.chPSC = initialFormData.chPSC
        this.formData.directors = initialFormData.directors
        this.formData.companyDirectors = initialFormData.companyDirectors
        this.formData.shareHolders = initialFormData.shareHolders
        this.formData.companyShareholders = initialFormData.companyShareholders
        this.formData.selectedDirector = initialFormData.selectedDirector
        this.formData.companiesHouseValidated = false
        delete this.formData.incorporationDate
        delete this.formData.addressSuggestion
      },
      submitForm (obj) {
        this.formData = merge(this.formData, obj, {arrayMerge: (destinationArray, sourceArray) => { return sourceArray }})
        localStorage.setItem('formData', JSON.stringify(this.formData))
        this.validated = true
        this.isValid = this.$refs.form.checkValidity()
        if (this.isValid) {
          if (this.regToken) return api.updateCompanyRegistration(this.formData, this.regToken).then(this.showNextFieldset)
          else {
            return api.createCompanyRegistration(this.formData).then(regToken => {
              this.regToken = regToken
              localStorage.setItem('regToken', this.regToken)
              this.showNextFieldset()
            })
          }
        } else this.$refs.form.querySelector('input:invalid,select:invalid,textarea:invalid').focus()
      },
      showNextFieldset () {
        this.changeFieldset(1)
      },
      showPrevFieldset () {
        this.changeFieldset(-1)
      }
    },
    async mounted () {
      this.$emit('set-title', 'Sign-up')
      const tokenParam = Object.keys(this.$route.query)[0]
      if (tokenParam) {
        this.regToken = tokenParam
        const companyRegistration = await api.getCompanyRegistration(this.regToken)
        this.formData = merge(this.formData, companyRegistration)
      }
      EventBus.$on('submit-form', this.submitForm)
      EventBus.$on('go-back', this.showPrevFieldset)
    }
  }
</script>

<style lang="scss" scoped>
</style>
